import "./App.css";
import Product from "./Pages/Product";
import Layout from "./Layout";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Favorites from "./Pages/Favorites";
import Profile from "./Pages/Profile";
import Cart from "./Pages/Cart";

function App() {

  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Product />} />
            <Route path="myfavorite" element={<Favorites/>} />
            <Route path="myprofile" element={<Profile/>}/>
            <Route path="cart" element={<Cart/>}/>
          </Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
